import { Box, Typography, Breadcrumbs, Link as MuiLink, useMediaQuery, useTheme, Stack } from '@mui/material'
import { Link } from 'react-router-dom'
import { NavigateNext } from '@mui/icons-material'

const PageHeader = ({ title, subtitle, breadcrumbs = [], actions, children }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box mb={3}>
      {breadcrumbs.length > 0 && (
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          sx={{ mb: 1, display: { xs: 'none', sm: 'flex' } }}
        >
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1
            return isLast ? (
              <Typography key={crumb.label} color="text.primary" fontSize="0.875rem">
                {crumb.label}
              </Typography>
            ) : (
              <MuiLink
                key={crumb.label}
                component={Link}
                to={crumb.path}
                color="inherit"
                underline="hover"
                fontSize="0.875rem"
              >
                {crumb.label}
              </MuiLink>
            )
          })}
        </Breadcrumbs>
      )}

      <Box
        display="flex"
        flexDirection={{ xs: 'column', sm: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', sm: 'flex-start' }}
        gap={2}
      >
        <Box>
          <Typography
            variant={isMobile ? 'h5' : 'h4'}
            fontWeight={700}
            color="text.primary"
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="text.secondary" mt={0.5}>
              {subtitle}
            </Typography>
          )}
        </Box>
        {actions && (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            sx={{
              '& > *': {
                width: { xs: '100%', sm: 'auto' },
              },
            }}
          >
            {actions}
          </Stack>
        )}
      </Box>
      {children}
    </Box>
  )
}

export default PageHeader
